// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 字体 */\n/* Colors\n-------------------------- */\n/* 尺寸\n-------------------------- */\n.check-popover {\n  padding: 0 !important;\n  min-width: 71px !important;\n  border: 1px solid #E4E7ED !important;\n  border-radius: 4px !important;\n}\n.check-popover .popper__arrow {\n    display: block !important;\n}\n", ""]);
// Exports
module.exports = exports;
